import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthenticationService } from '../authentication/services/authentication.service';

export const advanceAccessGuard: CanActivateFn = (route) => {
  const profile = inject(AuthenticationService).getProfileState();
  // The overview remains available; requesting and transaction actions stay restricted.
  const overview = ['advance', 'advance-only'].includes(
    route.routeConfig?.path ?? '',
  );
  return (
    (!!profile && (overview || !profile.disableAdvances)) ||
    inject(Router).createUrlTree(['/wallet'])
  );
};
